var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.55781C19 4.27789 14.748 0 9.5 0C4.25202 0 0 4.27789 0 9.55781C0 14.3282 3.47401 18.2824 8.01562 19V12.3207H5.60232V9.55781H8.01562V7.45201C8.01562 5.05678 9.43296 3.73371 11.6038 3.73371C12.6434 3.73371 13.7306 3.92024 13.7306 3.92024V6.27116H12.5323C11.3525 6.27116 10.9844 7.00803 10.9844 7.76379V9.55781H13.6191L13.1977 12.3207H10.9844V19C15.526 18.2824 19 14.3282 19 9.55781Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBw);
export default __webpack_public_path__ + "static/media/facebook-bw.0b9172ba5e34e3461fbb45d6f3bfeba8.svg";
export { ForwardRef as ReactComponent };